import { RunLogDocument } from '../../../service/AdminSpaceLoggingService';
import { buildRunLogMarkdown } from './runLogMarkdown';

const sanitize = (value: string): string =>
  value.replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || 'run';

const triggerDownload = (
  filename: string,
  text: string,
  mime: string,
): void => {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

const buildFilename = (doc: RunLogDocument, extension: string): string => {
  const flow = sanitize(doc.rootFlowName || 'run');
  const id = doc.processId.slice(0, 8);
  return `run-${flow}-${id}.${extension}`;
};

export const downloadRunLogMarkdown = (doc: RunLogDocument): void => {
  triggerDownload(
    buildFilename(doc, 'md'),
    buildRunLogMarkdown(doc),
    'text/markdown;charset=utf-8',
  );
};

export const downloadRunLogJson = (doc: RunLogDocument): void => {
  triggerDownload(
    buildFilename(doc, 'json'),
    JSON.stringify(doc, null, 2),
    'application/json;charset=utf-8',
  );
};
